import React, { useRef, useEffect } from 'react';
import styles from './topListWindow.css';
import { useSelector } from 'react-redux';
import Star from 'assets/svg/baseline-star-24px.svg';
import Replay from 'assets/svg/replay.svg';
import ReactWOW from '../../../../../../../components/react-wow/src';
import { getFontFamily,  getSwitchClassNameOrColourWithBackground, useForceUpdate, resizeListener } from '../../../../../../../utils/func';


/**
 *
 * @type {React.NamedExoticComponent<{readonly topList?: *, readonly placeColor?: *, readonly font_family?: *, readonly replayGame?: *, readonly isHideReplayButton?: *, readonly quiz?: *, readonly fontFamily?: *}>}
 */
// const TopListWindow = React.memo( ( { topList, placeColor, font_family, replayGame, isHideReplayButton, quiz } ) => {
const TopListWindow = React.memo( ( { isHideReplayButton, font_family, topList, placeColor,calendar} ) => {
    const forceUpdate = useForceUpdate();
    const { localization: { content } } = useSelector( ( state ) => state );
    let ref = useRef();

    useEffect(()=>{
        resizeListener(ref.current, ()=> forceUpdate());
    },[]);

    const getColor = () => {
        const { settings: { appearance} } = calendar;
        return  getSwitchClassNameOrColourWithBackground(appearance.background_color, styles.yourPlaceBl , styles.yourPlace);
    };

    const fontFamily = getFontFamily( font_family ).fontFamilyH2;
    const fontFamilDefault = getFontFamily( font_family ).defaultFont;
    const myBackgroundColor = getColor();

    return (
        <ReactWOW animation='fadeInUp' duration='0.5s'>
            <div ref={ref} className={ styles.wrapper }>

                <div style={ { fontFamily: fontFamily } } className={ styles.title }>
                    <Star style={ { fill: '#fff', width: '2.6rem', height: '3.1rem' } }/>
                    <span>{ content.calendar.top_list }</span>
                </div>
                <div className={ styles.listWrapp }>
                    { topList && topList
                        .sort( function ( a, b ) {
                            if ( a.position > b.position ) {
                                return 1;
                            }
                            if ( a.position < b.position ) {
                                return -1;
                            }
                            return 0;
                        } )
                        .map( ( el, index ) => (
                            
                            <div
                                style={ { fontFamily:fontFamilDefault } }
                                className={ el.isYou ? myBackgroundColor : styles.wrapperList }
                                key={ index }
                            >
                                <p className={ styles.place } style={ { color: placeColor } }>{ index + 1 }</p>
                                <p className={ styles.name }>{ el.name }</p>
                                <p className={ styles.points }>{ el.points }</p>
                            </div>
                        ) ) }
                </div>
            </div>
        </ReactWOW>
    );
} );

export default TopListWindow;